import { CdkStepper } from '@angular/cdk/stepper';
import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { MerchantEmployeeRequest, MerchantUserRolesEnum } from 'app/models';
import { MerchantUserService, StoreService } from 'app/services';
import { Utils } from 'app/utils';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { RolePermissionsComponent } from './role-permissions/role-permissions.component';
import { AppMaterialModule } from 'app/app-material.module';
import { CommonModule } from '@angular/common';
import { AppPrimengModule } from 'app/app-primeng-module';
import { TypeMerchantUserEnum } from 'app/models';

@Component({
  selector: 'create-merchant-single-employee',
  standalone: true,
  imports: [
    AppMaterialModule,
    CommonModule,
    ReactiveFormsModule,
    AppPrimengModule
  ],
  templateUrl: './create-merchant-single-employee.component.html',
  styleUrls: ['./create-merchant-single-employee.component.scss',
    '../../../../../../styles/m3-defaul-material-theme.scss'],
  providers: [MessageService, CdkStepper], encapsulation: ViewEncapsulation.None
})
export class CreateMerchantSingleEmployeeComponent implements OnInit{
  constructor(
     @Inject(MAT_DIALOG_DATA) public data: any,
     private formBuilder: FormBuilder,
     private messageService: MessageService,
     private dialog: MatDialog,
     public storeService: StoreService,
     private merchantUserService: MerchantUserService,
     private dialogRef: MatDialogRef<CreateMerchantSingleEmployeeComponent>
  ){
    this.minDate = new Date();
    this.tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));
  }

   @ViewChild('stepper') stepper!: MatStepper;
   employeeDetailsForm: FormGroup = new FormGroup({});
   roleForm: FormGroup = new FormGroup({});
   timeForm: FormGroup = new FormGroup({});
   progressInterval: any;
   progressBar: number = 0;
   loading: boolean = false;
   imageUrl: string = '';
   selectedStores: Array<string>[] = [];
   selectedIndex: number = 0;
   timeList = ['Now', '24 Hours', 'Custom'];
   minDate: Date;
   tomorrow: Date;
   public employeeType = TypeMerchantUserEnum;

   public storeRoles: any[] = [
        {
            id: MerchantUserRolesEnum.StoreManager,
            name: 'Store Manager'
        },
        {
            id: MerchantUserRolesEnum.Cashier,
            name: 'Cashier'
        },
        {
            id: MerchantUserRolesEnum.Dispatcher,
            name: 'Dispatcher'
        }
    ]
        ;
    public adminRoles: any[] = [
        {
            id: MerchantUserRolesEnum.Administrator,
            name: 'Administrator'
        }
   ];
   public stores: any[] = [];
   locationControl = new FormControl('');
   storesDto: any[] = [];
   public avatarHover = false;

   ngOnInit(): void {
    this.intializeEmployeeDetailsForm();
    this.intializeRoleForm();
    if(!this.data.isEditable){
        this.intializeTimeForm();
    }
    if(this.data.user){
        this.selectedStores = this.data.user.Stores?.map((x: any) => x.Name) ?? [];
    }
   }

   intializeEmployeeDetailsForm() {
    this.employeeDetailsForm = this.formBuilder.group({
      FirstName: [this.data.user.FirstName, Validators.required],
      LastName: [this.data.user.LastName, Validators.required],
      Email: [this.data.user.Email, [Validators.required, Validators.email]]
    });
   }

   intializeRoleForm() {
    this.roleForm = this.formBuilder.group({
      Role: [this.data.user.RoleId, Validators.required]
    });
   }

   intializeTimeForm() {
    this.timeForm = this.formBuilder.group({
      Time: ['', Validators.required]
    });
   }

   nextStep(type: string) {
    if(this.selectedIndex === 1){
        if(type === 'create'){
            this.stepper.next();
        } else {
            this.updateMerchant();
        }
    } else if(this.selectedIndex !== 2){
        this.stepper.next();
    } else {
        this.createMerchant();
    }
   }

   //Upload image
   public handleInputClick(id: string): void {
        document.getElementById(id)?.click();
   }

   public handleImageChange(event: Event) {
        this.loading = true;
        this.progressInterval = setInterval(() => {
            if (this.progressBar === 100) {
                clearInterval(this.progressInterval);
            } else {
                this.progressBar += 5;
            }
        }, 75);
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.imageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
        this.loading = false;
    }

    getRolePermissions(){
        this.dialog.open(RolePermissionsComponent, {
            width: '40%',
            height: '80%',
            data: {
              type: this.data.type,
              merchantId: this.data.merchantId
            }
        });
    }

    getStep(event: any) {
        this.selectedIndex = event.selectedIndex;
    }

    selectedStore(event: any) {
        const index = this.selectedStores?.indexOf(event.option.value);
        if (index < 0) {
            this.selectedStores.push(event.option.value);
            this.locationControl.setValue('');
        }

    }

    remove(store: any): void {
        const index = this.selectedStores?.indexOf(store);
        if (index >= 0) {
          this.selectedStores.splice(index, 1);
        }
    }

    resetTime() {
        this.timeForm.controls['Time'].setValue('');
    }

    getStoresIds(): number[] {
        this.stores.map(s => {
            this.selectedStores.map(store => {
                if(s.Name === store){
                    this.storesDto.push(s.Id);
                }
            });
        });
        return this.storesDto.length === 0 ? [this.data.storeId] : this.storesDto;
    }

    private getEmployeeDto(): MerchantEmployeeRequest {
        const customSendEmailDateTime = !this.data.isEditable ? (this.timeForm.controls['Time'].value !== 'Now' && this.timeForm.controls['Time'].value !== '24 Hours') ?
                moment(this.timeForm.controls['Time'].value).format('YYYY-MM-DDTHH:mm:ss') :
            this.timeForm.controls['Time'].value === 'Now' ?
                moment(this.minDate).format('YYYY-MM-DDTHH:mm:ss') :
                moment(this.tomorrow).format('YYYY-MM-DDTHH:mm:ss') :
            this.data.employee.CustomSendEmailDateTime;
        return {
            UserId: this.data.user.UserId,
            Email: this.employeeDetailsForm.controls['Email'].value,
            FirstName: this.employeeDetailsForm.controls['FirstName'].value,
            LastName: this.employeeDetailsForm.controls['LastName'].value,
            StoreIds: this.getStoresIds(),
            DelayInMin: -1,
            CustomSendEmailDateTime: customSendEmailDateTime,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            MerchantId: this.data.merchantId,
            RoleId: this.roleForm.controls['Role'].value,
            NewEmployeeRoleId: this.roleForm.controls['Role'].value,
            Password: 'Pass1234',
            IsSimplifiedCreation: true,
        };
    }

    createMerchant() {
        const dto = this.getEmployeeDto();

        this.loading = true;
        this.merchantUserService.createMerchantUser(dto, this.messageService)
        .then(data => {
            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.loading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Employee has been added' });
            this.dialogRef.close(true);
        })
        .catch(err => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
            throw err;
        });
    }

    updateMerchant() {
        const dto = this.getEmployeeDto();

        this.loading = true;
        this.merchantUserService.updateMerchantUser(dto, this.messageService)
        .then(data => {
            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.loading = false;
            this.dialogRef.close(true);
        })
        .catch(err => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
        });
    }
}
